export default {
  carouselImg: 'mx-auto',
};
